import { Badge } from 'react-daisyui';
import { Link } from 'react-router-dom';
import { PORTAL_ROUTES } from 'utils/constants';
import { formatDate } from 'utils/helpers';

const STATUS_COLORS = {
  unpaid: 'bg-amber-100 text-amber-600 border-amber-200',
  paid: 'bg-green-100 text-green-700 border-green-200',
};

const Item = ({ data }) => {
  const { amount, state, due_at, resource } = data.attributes || {};
  const charge = resource?.data?.attributes || {};

  return (
    <Link to={`${PORTAL_ROUTES.CHARGES}/${charge?.encoded_id}`} className="card bg-base-100 border border-base-200 shadow-sm hover:shadow-md transition-shadow block">
      <div className="card-body p-5">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="font-semibold text-secondary-900">Manual Charge</h3>
            <p className="text-xs text-secondary-400 mt-0.5">{formatDate(due_at, 'short')}</p>
          </div>
          <Badge className={`text-xs font-semibold border ${STATUS_COLORS[state] || 'bg-gray-100 text-gray-600 border-gray-200'}`}>
            {state.charAt(0).toUpperCase() + state.slice(1)}
          </Badge>
        </div>

        <div className="flex items-center justify-between">
          <p className="text-xs text-secondary-400">Due {formatDate(due_at, 'short')}</p>
          <span className="text-sm font-bold text-secondary-900">${parseFloat(amount).toFixed(2)}</span>
        </div>
      </div>
    </Link>
  );
};

export default Item;
